import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_cursor.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconCursor = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconCursor;
